import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Icon, Label, Menu, Table } from 'semantic-ui-react';

// Every row of the uploaded file and what will happen to it, so a user can check the
// whole list before importing rather than a sample of it
const STATUSES = [
  { key: 'new', text: 'Will be added', color: 'green' },
  { key: 'already', text: 'Already on campaign', color: 'grey' },
  { key: 'duplicate', text: 'Duplicate', color: 'purple' },
  { key: 'invalid', text: 'Not valid', color: 'red' },
  { key: 'header', text: 'Header, skipped' },
];

const FILTERS_STYLE = { margin: '14px 0 10px', flexWrap: 'wrap' };
// Rendered as buttons so the tabs can be reached by keyboard - this resets the browser's
// button chrome, leaving the bottom border to the pointing menu's underline
const FILTER_TAB_STYLE = {
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  background: 'none',
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  font: 'inherit',
  cursor: 'pointer',
};
const SCROLL_STYLE = { maxHeight: '340px', overflowY: 'auto' };
const INPUT_STYLE = { wordBreak: 'break-all' };
const NO_WRAP_STYLE = { whiteSpace: 'nowrap' };
const REASON_STYLE = { marginTop: '4px', fontSize: '12px', color: '#767676' };
const ROW_CELL_STYLE = { width: '60px' };

class CsvRowsTable extends Component {
  constructor(props) {
    super(props);
    this.state = { filter: 'all' };
  }

  handleFilterClick = (event, { name }) => {
    this.setState({ filter: name });
  };

  renderFilters = counts => {
    const { rows } = this.props;
    const { filter } = this.state;
    const filters = [
      { key: 'all', text: 'All', count: _.size(rows) },
      ..._.map(_.reject(STATUSES, { key: 'header' }), status => ({ ...status, count: counts[status.key] || 0 })),
    ];

    return (
      <Menu secondary pointing style={FILTERS_STYLE}>
        {_.map(_.filter(filters, f => f.key === 'all' || f.count > 0), f => (
          <Menu.Item
            as="button"
            key={f.key}
            name={f.key}
            active={filter === f.key}
            aria-pressed={filter === f.key}
            style={FILTER_TAB_STYLE}
            onClick={this.handleFilterClick}
          >
            {f.text}
            <Label size="small" color={f.color}>{f.count}</Label>
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  renderStatus = row => {
    const status = _.find(STATUSES, { key: row.status });

    return (
      <div>
        <Label size="small" color={status.color} basic={!status.color} style={NO_WRAP_STYLE}>{status.text}</Label>
        {row.status === 'invalid' && <div style={REASON_STYLE}>{row.validationError}</div>}
      </div>
    );
  };

  render() {
    const { rows } = this.props;
    const { filter } = this.state;
    const counts = _.countBy(rows, 'status');
    const visibleRows = filter === 'all' ? rows : _.filter(rows, { status: filter });

    return (
      <div>
        {this.renderFilters(counts)}
        <div style={SCROLL_STYLE}>
          <Table celled compact unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell style={ROW_CELL_STYLE}>Row</Table.HeaderCell>
                <Table.HeaderCell>In your file</Table.HeaderCell>
                <Table.HeaderCell>Instagram handle</Table.HeaderCell>
                <Table.HeaderCell>Result</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {_.map(visibleRows, row => (
                <Table.Row key={row.originalRow} disabled={row.status === 'header'}>
                  <Table.Cell>{row.originalRow}</Table.Cell>
                  <Table.Cell style={INPUT_STYLE}>{row.originalInstagramInput || '-'}</Table.Cell>
                  <Table.Cell singleLine>
                    {row.instagramHandle
                      ? <span><Icon name="instagram" />{row.instagramHandle}</span>
                      : '-'}
                  </Table.Cell>
                  <Table.Cell>{this.renderStatus(row)}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}

CsvRowsTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    originalRow: PropTypes.number,
    originalInstagramInput: PropTypes.string,
    instagramHandle: PropTypes.string,
    status: PropTypes.oneOf(_.map(STATUSES, 'key')),
    validationError: PropTypes.string,
  })),
};

CsvRowsTable.defaultProps = {
  rows: [],
};

export default CsvRowsTable;



/** WEBPACK FOOTER **
 ** ./src/components/csv-upload-modal/rows-table.js
 **/